import React, { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom"; // For linking to the "Add New Project" page
import {
  getProjectRequests,
  setProjectsSize,
  unsetProjects,
} from "../../features/projectsSlice"; // Redux action to fetch ongoing projects
import Loading from "../../components/loading/Loading";
import PageTitle from "../../components/titles/PageTitle";
import SecondContainer from "../../components/container/SecondContainer";
import { useAuthorization } from "../../hooks/useAuthorization";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";
import PaginationSecondBar from "../../components/pagination/PaginationSecondBar";

const MyProposal = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const projects = useSelector((state) => state.projects.data); // List of ongoing projects
  const total = useSelector((state) => state.projects.total);
  const pageSize = useSelector((state) => state.projects.size); // List of ongoing projects
  const user = useSelector((state) => state.user.userInfo); // List of ongoing projects
  const loading = useSelector(
    (state) => state.projects.load.getProjectRequests
  );

  const onPageChange = async (limit, offset) => {
    try {
      if (user.province_id) {
        dispatch(
          getProjectRequests({
            desk: "proposal",
            id: user.province_id,
            community_id: user.communities[0].id,
            limit,
            offset,
          })
        );
      }
    } catch (error) {}
  };

  // Fetch ongoing projects when the component mounts
  useLayoutEffect(() => {
    if (user.province_id) {
      dispatch(
        getProjectRequests({
          desk: "proposal",
          id: user.province_id,
          community_id: user.communities?.[0]?.id,
          limit: pageSize,
          reload: true,
        })
      );
    }

    return () => {
      dispatch(unsetProjects());
    };
  }, [user]);

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <SecondContainer className="  ">
      <PageTitle title="Proposal" />
      {/* Basic Instructions */}
      {/* <h1 className="text-2xl text font-bold mb-4">Ongoing Applications</h1> */}
      {/* <p className="mb-4 text-text-1/65">
        Below is a list of all ongoing applications. You can view the details of
        each project, see the current step, and continue your application. To
        start a new application, click the "New Application" button.
      </p> */}

      {/* Ongoing Applications Table */}

      <>
        <PaginationSecondBar
          loading={loading}
          onPageChange={onPageChange}
          total={total}
        />
        {/* <PaginationBar
          total={total}
          pageSize={pageSize}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          loading={loading}
          nextCount={nextCount}
          prevCount={prevCount}
          prevId={projects.length > 0 ? projects[0].id : ""}
          nextId={projects.length > 0 ? projects[projects.length - 1].id : ""}
        /> */}
        <div className="table-container">
          <table className="app-table">
            <thead className=" app-thead">
              <tr>
                <th className="app-thead-th">Num</th>
                <th className="app-thead-th">Title</th>
                <th className="app-thead-th">Last Saved</th>
                <th className="app-thead-th">Status</th>
                {isAuthorized("pdo_department", "update") && (
                  <th className="app-thead-th">Action</th>
                )}
              </tr>
            </thead>
            {loading === loadStatus.loading ? (
              <tr className="!border-none !bg-transparent">
                <td colSpan={6} className="!border-none !border-transparent ">
                  <div className="h-72 flex items-center justify-center mx-auto w-fit !border-none">
                    <Loading />
                  </div>
                </td>
              </tr>
            ) : projects.length > 0 ? (
              <tbody className="text-text-1/85">
                {projects.map((project, index) => (
                  <tr key={project.id}>
                    {/* Project Num */}
                    <td className="table-data !text-sm">{++index}</td>
                    {/* Project Title */}
                    <td className="table-data !text-base">
                      {project.name.length >= 30
                        ? project.name.slice(0, 35) + "....."
                        : project.name}
                    </td>

                    {/* Date Started */}
                    <td className="table-data !text-sm">
                      {new Date(project.updated_at).toDateString()}
                    </td>

                    {/* Step Reached (Assumed it's available in the project object) */}
                    <td className="table-data !text-sm">
                      {project.stage.step || "Not Started"}
                    </td>

                    {/* Continue Application Button */}
                    {isAuthorized("pdo_department", "update") && (
                      <td className="table-data !text-sm text-center">
                        {project.stage?.desk === "proposal" ? (
                          <Link to={project.stage.url}>
                            <button className="px-4 py-2 bg-green-500/80 text-white rounded hover:bg-green-600">
                              Develop Proposal
                            </button>
                          </Link>
                        ) : (
                          <p className="inline-block px-4 py-2 bg-slate-400 text-white rounded ">
                            Pending Approval
                          </p>
                        )}
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            ) : (
              <>
                <tr className="!border-none !bg-transparent">
                  <td colSpan={6} className="!border-none !border-transparent ">
                    <div className="flex items-center justify-center w-full h-72 border border-bkg2 rounded-md">
                      <p className="text-text-1/60">
                        No ongoing Proposals found.
                      </p>
                    </div>
                  </td>
                </tr>
              </>
            )}
          </table>
        </div>
      </>
    </SecondContainer>
  );
};

export default MyProposal;
